import { deepExtract } from 'helpers/deep';
export var shouldSkipPhoneVerification = deepExtract.bind(null, 'features.phoneVerification.skipVerification');